import MatchedMap from 'utilities/src/matchedMap';

import { type TFormField } from '../../shared/utils/types';

import { ThemeEnum, useTheme } from '../../../Theme';

import checkboxCommonTheme from './_common';

import checkboxBlogTheme from './_blog';
import checkboxSiteTheme from './_site';
import { ICheckboxProps } from '../_props';

const checkboxThemes = new MatchedMap([
  [ThemeEnum.Blog, checkboxBlogTheme],
  [ThemeEnum.Site, checkboxSiteTheme],
]);

const useCheckboxTheme = (fieldThemeProps: Pick<ICheckboxProps<TFormField>, 'state' | 'type' | 'theme'>) =>
  useTheme(checkboxCommonTheme(fieldThemeProps), checkboxThemes);

export default useCheckboxTheme;
